import React, {FC, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap-v5'
import {fullName, TRACKING_STATUS_OPTIONS, TrackingStatus} from '../application/ApplicationModel'
import {ITrackingModel, ITrackingUpdateRequest} from './TrackingModel'

type Props = {
  tracking: ITrackingModel | null
  loading: boolean
  onClose: () => void
  onSubmit: (request: ITrackingUpdateRequest) => void
}

/** Durum ve not; adım değişikliği ilerle/geri butonlarıyla yapılır */
export const TrackingEditModal: FC<Props> = ({tracking, loading, onClose, onSubmit}) => {
  const [status, setStatus] = useState<TrackingStatus>('IN_PROGRESS')
  const [note, setNote] = useState('')

  useEffect(() => {
    if (!tracking) return
    setStatus(tracking.status)
    setNote(tracking.note ?? '')
  }, [tracking])

  return (
    <Modal show={!!tracking} onHide={onClose} dialogClassName='modal-dialog-centered' backdrop='static'>
      <form
        onSubmit={(event) => {
          event.preventDefault()
          onSubmit({status, note: note.trim()})
        }}
      >
        <div className='modal-header'>
          <h5 className='modal-title'>Aday Takibini Düzenle</h5>
          <button type='button' className='btn-close' onClick={onClose} />
        </div>
        <div className='modal-body'>
          <div className='text-muted mb-6'>
            {tracking && fullName(tracking)} · {tracking?.currentStepName}
          </div>
          <div className='mb-5'>
            <label className='form-label fw-bold required'>Durum</label>
            <select
              className='form-select'
              value={status}
              onChange={(event) => setStatus(event.target.value as TrackingStatus)}
            >
              {TRACKING_STATUS_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            <div className='form-text'>İptal edilen süreç ilerletilemez; tekrar "Devam ediyor" yapılabilir.</div>
          </div>
          <label className='form-label fw-bold'>Not</label>
          <textarea
            rows={5}
            maxLength={5000}
            className='form-control'
            placeholder='Görüşme notları, değerlendirme vb.'
            value={note}
            onChange={(event) => setNote(event.target.value)}
          />
        </div>
        <div className='modal-footer'>
          <button type='button' className='btn btn-light' onClick={onClose}>
            İptal
          </button>
          <button type='submit' className='btn btn-primary' disabled={loading}>
            {loading ? <span className='spinner-border spinner-border-sm' /> : 'Kaydet'}
          </button>
        </div>
      </form>
    </Modal>
  )
}
